import React from 'react';

/**
 * WindDirectionArrow component
 * Renders an SVG arrow rotated based on wind direction in degrees.
 * 0° = North (Arrow points Up)
 * 90° = East (Arrow points Right)
 * 180° = South (Arrow points Down)
 * 270° = West (Arrow points Left)
 */
const WindDirectionArrow = ({ cx, cy, value, stroke, size = 16 }) => {
    // Safety check: if value is not a number, don't render
    const numericValue = typeof value === 'number' ? value : parseFloat(value);
    if (isNaN(numericValue)) return null;

    // In meteorology, 0 degrees is North. 
    // SVG rotation is clockwise.
    // An arrow path that points UP at 0 rotation matches the convention.
    // The rotation should be around the center (cx, cy).

    return (
        <g transform={`rotate(${numericValue}, ${cx}, ${cy})`}>
            {/* Simple Minimal Arrow: A line with a triangle head pointing UP */}
            <line
                x1={cx}
                y1={cy + size / 2}
                x2={cx}
                y2={cy - size / 2}
                stroke={stroke}
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d={`M ${cx - size / 3} ${cy - size / 6} L ${cx} ${cy - size / 2} L ${cx + size / 3} ${cy - size / 6}`}
                fill="none"
                stroke={stroke}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            {/* Small dot at the center for clarity */}
            <circle cx={cx} cy={cy} r={2} fill={stroke} />
        </g>
    );
};

/**
 * Helper to get cardinal direction from degrees
 */
export const getCardinalDirection = (deg) => {
    if (deg === null || deg === undefined || isNaN(deg)) return "";
    const val = Math.floor((deg / 22.5) + 0.5);
    const arr = ["N", "NNE", "NE", "ENE", "E", "ESE", "SE", "SSE", "S", "SSW", "SW", "WSW", "W", "WNW", "NW", "NNW"];
    return arr[(val % 16)];
};

export default WindDirectionArrow;
